module.exports = __webpack_public_path__ + "static/img/bottom_sheet_up_body.6e87ce3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/smart/bottom_sheet_up_body.png
// module id = PQ3W
// module chunks = 1